import {BaseRemoteConfiguration, REMOTE_CONFIG} from "../../infrastructure/models/base-remote-configuration";

export const WEBSITE_MODULE_REMOTE_CONFIG = {
  MAX_NUMBER_OF_DISPLAY: {
    key: 'MAX_NUMBER_OF_DISPLAY',
    default: 3,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  DAYS_WITHOUT_SELECTION_ACTIVITY: {
    key: 'DAYS_WITHOUT_SELECTION_ACTIVITY',
    default: 30,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  BOLAO_SHOW_PROMOTION: {
    key: 'BOLAO_SHOW_PROMOTION',
    default: false,
    type: REMOTE_CONFIG.KEY_TYPES.boolean
  },

  WEB_TO_APP_CTA: {
    key: 'WEB_TO_APP_CTA',
    default: "null",
    type: REMOTE_CONFIG.KEY_TYPES.json
  }
}

export class WebsiteModuleRemoteConfig extends BaseRemoteConfiguration {
  static injectables = [...BaseRemoteConfiguration.injectables];

  get defaultConfig() {
    return Object.values(WEBSITE_MODULE_REMOTE_CONFIG);
  }
}
